import React from "react";
import Header from "../../Layouts/Header";
import "./index.css"; // Your styles
import "../../CommonContainer/common.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import bannerSubimg from "../../../Assets/images/Jewellery/j-img.png";

import Necklace from "../../CommonContainer/Necklace";

import { useNavigate } from "react-router-dom";

import bannersubimage1 from "../../../Assets/images/jewellery-image.png"


import jewelleryimage from "../../../Assets/images/jewelleryimage.png"




const Jewellery = () => {
    const navigate = useNavigate();
  
      const contactus = () => {
          navigate("/contact-us")
      }
  return (
    <>
      <div className="about-hero-section jwellery-banner">
        <Header />
        <div className="common-width-home-main-container">
          <div className="about-banner1-main-section">
            <div>
              <h1>Gold-Kissed Silver, Worn with Grace</h1>
              <p>Where tradition meets shimmer — 92.5 silver jewelry with a touch of gold elegance</p>
              <button className="contact-button" onClick={contactus}>Contact Us</button>
            </div>
            <img src={jewelleryimage} alt="banner1" />
          </div>
        </div>
      </div>

      <div className="jewellery-carousel-section">
       <Necklace/>

      </div>
    </>
  );
};

export default Jewellery;
